// 数据库菜单
export const DBS = ['/db/formula', '/db/term', '/db/param', '/db/qa']

// 社区菜单
export const SQS = ['/news', '/community', '/slist']

// 书架菜单
export const BKS = ['/book', '/book/index', '/book/list']